import { useMemo, useState } from "react";
import { router } from "@inertiajs/react";
import { onboarding_path } from "@/lib/routes";
import { deriveWorkplaces, type OrgTreeNode } from "@/lib/orgTree";
import RequestAccessFlow from "./request/RequestAccessFlow";
import type { Department, Profile, RequestPayload } from "./request/types";

export type { OrgTreeNode };

type Props = {
  org_name: string;
  profile: {
    name: string;
    email: string;
  };
  org_tree: OrgTreeNode[];
  departments: Department[];
  errors?: Record<string, string | string[]>;
};

// Wires the presentational RequestAccessFlow to the real onboarding backend.
// Derives searchable Workplaces (label + breadcrumb) from the org tree so the
// hierarchy stays hidden, and POSTs to OnboardingController#complete
// (org_node_id + role_note) — the existing approval-first endpoint.
export default function SignupRequestFlow({ org_name, profile, org_tree, departments, errors }: Props) {
  const [submitting, setSubmitting] = useState(false);

  const workplaces = useMemo(() => deriveWorkplaces(org_tree), [org_tree]);

  const flowProfile: Profile = {
    name: profile.name,
    email: profile.email,
  };

  const submit = (payload: RequestPayload) => {
    setSubmitting(true);
    router.post(onboarding_path(), payload, {
      onFinish: () => setSubmitting(false),
    });
  };

  return (
    <RequestAccessFlow
      orgName={org_name}
      profile={flowProfile}
      workplaces={workplaces}
      departments={departments}
      submitting={submitting}
      errors={errors}
      onSubmit={submit}
    />
  );
}
